import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getFilters = (state) => get(state, 'users.filters', {});
export const getPagination = (state) => get(state, 'users.pagination', {});
export const getIsLoading = (state) => get(state, 'users.isLoading', false);
export const getNeedFetch = (state) => get(state, 'users.needFetch', false);

export const getUsers = (state) => get(state, 'users.entities.users', {});
export const getUsersIds = (state) => get(state, 'users.result.users', []);
export const getEditingUser = (state) => get(state, 'users.editing', []);

export const getVisibleUsers = createSelector([getUsersIds, getUsers], (ids, users) =>
  ids.map((id) => users[id])
);



// WEBPACK FOOTER //
// src/modules/secured/modules/users/selectors/users_selectors.js